

import React from 'react';
import CommonGrid from '../../../components/CommonCompo/CommonGrid/CommonGrid';
import { useWelcomeKitList } from '../../../Hooks/Features/WelcomeKitList/useWelcomeKitList';
import { useCommon } from '../../../Hooks/Common/useCommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function WelcomeKitList() {
  const { filterOpts, columns, rowData, tagRef, loader, filterValues, setFilterValues, getWelcomeKitData, search, onFilterTextBoxChanged } = useWelcomeKitList();
  const { checkPermission } = useCommon();
  return (
    <div ref={() => checkPermission("welcomekit", tagRef)}>
      <div ref={tagRef} id='{"tabname": "welcomekit", "data": "welcomekit_list"}'>
        <div className='d-flex justify-content-between align-items-center my-2 '>
          <div className='d-flex gap-2 '>
            <input type="text" id="filter-text-box" placeholder="Search..." onInput={(e) => onFilterTextBoxChanged(e.target.value)} value={search} className='input-dd' />
            {filterOpts?.Status?.map((type) => (
              <div className="d-flex align-items-center" key={type.value}>
                <input type="radio" id={type.label} name="statusFilter" value={type.value} onChange={() => setFilterValues(prev => ({ ...prev, Status: type }))} checked={filterValues?.Status?.value === type.value} />
                <label htmlFor={type.label}>{type.label}</label>
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2 ">
            <button className="sk-btn-primary" onClick={() => getWelcomeKitData()} title="Refresh">
              <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
            </button>
          </div>
        </div>
        <div style={{ height: "calc(100vh - 120px)", overflowY: "auto", width: filterValues.Status.value === "pending" || filterValues.Status.value === "done" ? '30%' : '100%' }}>
          <CommonGrid columns={columns} data={rowData} loader={loader} headerHeight={50} />
        </div>
      </div>
    </div>
  );
}
export default WelcomeKitList;